import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updatePartnerAccountant } from '../../api/partner-accountant.ts';
import type { UpdatePartnerAccountantRequest } from '../../api/requests/partner-accountant-request.ts';

export default function useUpdatePartnerAccountant(): UseMutationResult<
  string,
  Error,
  UpdatePartnerAccountantRequest
> {
  return useMutation({
    mutationFn: updatePartnerAccountant,
  });
}
